const initialState = {
  title: null,
  msg: {},
  status: null,
};

const infoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_INFO":
      return {
        msg: action.payload.msg,    
        title: action.payload.title,
        status: action.payload.status,
      };
    case "CLEAR_INFO":
      return initialState;
    default:
      return state;
  }
};

export const returnInfo = (msg, status, title = "") => {
  return {
    type: "GET_INFO",
    payload: { msg, status, title },
  };
};

export const clearInfo= () => {
  return {
    type: "CLEAR_INFO",
  };
};

export default infoReducer;
